<template>
  <div v-if="currentOffre && currentCandidature">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Candidatures'"
          :description="'Modification d\'une candidature'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17">
                  <td class="col-12 text-center font-weight-bold">
                    Recrutement concerné
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td
                    class="col-6 text-custom-primary d-flex justify-content-between"
                  >
                    <div>Référence : {{ currentOffre.document.reference }}</div>
                    <div>
                      <router-link
                        :to="{
                          name: 'rh_offre_emploi-show',
                          params: { id: currentOffre.id },
                        }"
                        title="Aperçu"
                      >
                        <i
                          :class="icons.ICON_SHOW"
                          class="text-custom-primary font-size-17"
                        ></i>
                      </router-link>
                    </div>
                  </td>
                  <td class="col-6 font-weight-bold">
                    Poste : {{ currentOffre.poste.nom }}
                  </td>
                </tr>
                <tr class="d-flex">
                  <td class="col-6 font-weight-bold">
                    Période :
                    {{ currentOffre.date_debut }}
                    -
                    {{ currentOffre.date_fin }}
                  </td>
                  <td class="col-6 font-weight-bold">
                    Nombre de poste :
                    {{ currentOffre.nbre_poste }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row" v-if="currentCandidature.document">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Référence candidature :
                    {{ currentCandidature.document.reference }}
                  </td>
                  <td class="col-6">
                    Statut :
                    <i
                      :style="`color: ${currentCandidature.statut.couleur}`"
                      class="mr-1"
                      :class="icons.ICON_STATUT"
                    ></i>
                    {{ currentCandidature.statut.nom }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="$router.push(prov).catch(() => {})"
        >
          Liste des candidatures
        </button>
        <button
          v-if="currentOffre.statut === 0"
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router
              .push({
                name: 'rh_candidature-create',
                params: { offreId: currentOffre.id, prov: prov },
              })
              .catch(() => {})
          "
        >
          <i :class="icons.ICON_ADD"></i>
          Nouvelle candidature
        </button>
        <button
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({
                name: 'rh_candidature-show',
                params: {
                  id: currentCandidature.id,
                  offreId: currentOffre.id,
                  prov: prov,
                },
              })
              .catch(() => {})
          "
        >
          <i :class="icons.ICON_SHOW" class="font-size-17"></i> Aperçu
        </button>
      </div>
      <div class="col-md-12 col-lg-6" v-if="currentOffre.statut === 0">
        <button
          type="button"
          class="btn btn-custom-primary"
          @click="showModalStatut"
        >
          Changer le statut
        </button>
        <button
          type="button"
          title="Embaucher le candidat"
          class="btn btn-custom-primary ml-4"
          @click.prevent="
            $router
              .push({
                name: 'rh_employe-create',
                params: { filter: 'candidat', id: currentCandidature.id },
              })
              .catch(() => {})
          "
        >
          <i class="font-size-17" :class="icons.ICON_EMBAUCHER"></i> Embaucher
          le candidat
        </button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: 'rh_candidature-edit',
                params: {
                  id: currentCandidature.id,
                  offreId: currentOffre.id,
                  prov: prov,
                },
              }"
              exact
              exact-active-class="active"
              ><i
                :class="icons.ICON_EDIT"
                class="text-custom-primary font-size-17"
              ></i
              >Candidature</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_candidature_edit-document',
                params: {
                  id: currentCandidature.id,
                  offreId: currentOffre.id,
                  prov: prov,
                  documentUuid: currentCandidature.document.uuid,
                },
              }"
              exact
              exact-active-class="active"
              ><i
                :class="icons.ICON_DOCUMENT"
                class="text-custom-primary font-size-17"
              ></i>
              Documents</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'rh_candidature_edit_activite',
                params: {
                  id: currentCandidature.id,
                  offreId: currentOffre.id,
                  prov: prov,
                },
              }"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Suivi de candidature</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
    <ModalStatut
      ref="modalStatut"
      :currentCandidature="currentCandidature"
      :statuts="statuts"
      @onChangeStatut="onChangeStatut"
    />
  </div>
</template>

<script>
import URL_C from '@/http/rh/candidature/candidature';
import URL_O from '@/http/rh/offre-emploi';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import { editLayout as icons } from '@/icons/rh/candidature';
import CONST from '@/constants/rh/candidature';
import ModalStatut from '../components/ModalStatut.vue';

export default {
  data() {
    return {
      prov: this.$route.params.prov,
      title: 'Gestion des candidatures',
      icons,
      CONST,
    };
  },
  computed: {
    ...mapGetters('candidature', ['currentCandidature', 'statuts']),
    ...mapGetters('offreEmploi', ['currentOffre']),
  },
  components: {
    ModalStatut,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('candidature', ['setCurrentCandidature', 'setStatuts']),
    ...mapActions('offreEmploi', ['setCurrentOffre']),
    showModalStatut() {
      this.$refs.modalStatut.showModal();
    },
    onChangeStatut(candidature) {
      this.setCurrentCandidature(candidature);
    },
    init() {
      this.setCurrentCandidature(null);
      this.setCurrentOffre(null);
      this.setStatuts([]);

      window.axios
        .all([
          window.axios.get(
            URL_O.OFFRE_EMPLOI + '/' + this.$route.params.offreId
          ),
          window.axios.get(URL_C.CANDIDATURE + '/' + this.$route.params.id, {
            params: { edit: true },
          }),
          window.axios.get(URL_C.GET_REQUIREMENTS),
        ])
        .then(
          window.axios.spread((resp1, resp2, resp3) => {
            this.setCurrentOffre(resp1.data.offre_emploi);
            this.setCurrentCandidature(resp2.data.candidature);
            this.setStatuts(resp3.data.statuts);
          })
        )
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
